import { commonRegx } from "xcommon-node/src/common/commonRegx";
import { EntityAttendance } from "../../entity/EntityAttendance";

export class DtoAttendancesPostReq extends EntityAttendance {
  public IsValid(): string[] {
    let res: string[] = new Array();
    //単項目チェック
    //--------------

    return res;
  }
}
